module.exports = __webpack_public_path__ + "img/Metatext_zapier-illustration2.6735a2e5.jpg";